"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localUserTypePolicy = void 0;
exports.localUserTypePolicy = {
    UserWithPermissions: {
        fields: {
            isInternal: {
                read(_, { readField }) {
                    const email = readField('email');
                    let domain = null;
                    if (email) {
                        domain = email.substring(email.lastIndexOf('@') + 1);
                    }
                    return !!domain && (domain.toLowerCase() === 'snapraise.com' || domain.toLowerCase() === 'snap-raise.com');
                },
            },
        },
    },
};
